import { Component, HostListener, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import {
  AppSwitchDialogComponent,
  AppSwitchDialogData,
} from './app-switch-dialog.component';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { QrCodePreviewComponent } from '../qr-code-preview/qr-code-preview.component';

@Component({
  selector: 'qa-app-button',
  templateUrl: './app-button.component.html',
  styleUrl: './app-button.component.scss',
  imports: [MatIcon, TranslateModule, QrCodePreviewComponent],
})
export class AppButtonComponent {
  @Input() qrSVG: SafeHtml;
  @Input() pinCode: string;

  constructor(private matDialog: MatDialog) {}

  @HostListener('click')
  onClick() {
    this.matDialog.open<AppSwitchDialogComponent, AppSwitchDialogData>(
      AppSwitchDialogComponent,
      {
        data: {
          qrSVG: this.qrSVG,
          contentUrl: window.location.href,
          pinCode: this.pinCode,
        },
        maxWidth: '90vw',
        width: '850px',
        panelClass: 'app-switch-dialog-panel',
      }
    );
  }
}
